// --------------------------------------------------------------
// Created On: 2021-10-27
// Author: Zachary Thomas
//
// Last Modified: 2022-05-24
// Modified By: Zachary Thomas
//
// Copyright 2021 - 2022 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PropTypes, { InferProps } from "prop-types";
import { useLocation } from "react-router-dom";
import styles from "./NavigationDrawerLink.module.scss";

// A single selectable page link.
export default function NavigationDrawerLink(props: Props): Component {
  const [assetId, setAssetId] = useState<string>("0");
  const location = useLocation();

  // Update the asset ID based on the current location.
  useEffect(() => {
    const pathSubdirectories = location.pathname.split("/");
    if (pathSubdirectories.length > 2) {
      setAssetId(pathSubdirectories[2]);
    }
  }, [location.pathname]);

  return (
    <Link
      className={styles.body}
      to={props.linksToAsset ? props.targetPage.replace("*", assetId) : props.targetPage}
      onClick={() => props.onClick()}
    >
      <div
        data-test="nav-drawer-link"
        className={`${styles.link} p-3 ${
          props.linksToAsset
            ? props.targetPage.replace("*", assetId) === location.pathname
              ? styles.selected
              : ""
            : props.targetPage === location.pathname
            ? styles.selected
            : ""
        }`}
      >
        {props.name}
      </div>
    </Link>
  );
}

NavigationDrawerLink.propTypes = {
  name: PropTypes.string.isRequired,
  targetPage: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  linksToAsset: PropTypes.bool,
};

type Props = InferProps<typeof NavigationDrawerLink.propTypes>;
